import { render, staticRenderFns } from "./Anm22Board.vue?vue&type=template&id=9967f204&scoped=true&"
import script from "./Anm22Board.vue?vue&type=script&lang=js&"
export * from "./Anm22Board.vue?vue&type=script&lang=js&"
import style0 from "./Anm22Board.vue?vue&type=style&index=0&id=9967f204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9967f204",
  null
  
)

export default component.exports